// Central content for Desert Vibe Media

export const SOCIAL = {
  instagram: "https://www.instagram.com/desertvibemedia",
  facebook: "https://www.facebook.com/desertvibemedia",
  googleReview: "https://maps.app.goo.gl/iuTL3DQjQoaVBXRC6?g_st=ic",
};


export const IMAGES = {
  logo: "/logo-desertvibe.png",
  heroVideo: "https://customer-assets.emergentagent.com/job_dune-productions/artifacts/i1cmomif_DVMwebsite.mp4",
  hero: "https://customer-assets.emergentagent.com/job_dune-productions/artifacts/biul32p4_DJI_20250223151127_0018_D.webp",
  canyon: "https://customer-assets.emergentagent.com/job_dune-productions/artifacts/xe2uxw73_2019_0113_22414300.webp",
  sunset: "https://customer-assets.emergentagent.com/job_dune-productions/artifacts/w24ifuob_13693052_10201833708001317_441654772065006527_o.webp",
  bts: "https://customer-assets.emergentagent.com/job_dune-productions/artifacts/ifetxdei_290665908_1458736621239566_9023307945821371892_n.jpg",
  camera: "https://images.unsplash.com/photo-1553166272-e69910ab5ae1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHw0fHx2aWRlbyUyMHByb2R1Y3Rpb24lMjBmaWxtJTIwY2FtZXJhfGVufDB8fHx8MTc4MzY5OTM0MHww&ixlib=rb-4.1.0&q=85",
  hawk: "https://images.unsplash.com/photo-1642202920533-e313db1986ea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwzfHxoYXdrJTIwZmx5aW5nJTIwZGVzZXJ0fGVufDB8fHx8MTc4MzY5OTMzOXww&ixlib=rb-4.1.0&q=85",
  owl: "https://images.unsplash.com/photo-1772266137447-09ef4ad7f2b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwyfHxvd2wlMjBpbiUyMGRlc2VydHxlbnwwfHx8fDE3ODM2OTkzMzl8MA&ixlib=rb-4.1.0&q=85",
};

export const SERVICES = [
  {
    no: "01",
    title: "Cinematic Films",
    desc: "Brand films and narrative pieces shot with cinema-grade glass, graded for the emotion your story deserves.",
    tags: ["Brand Films", "Narrative", "Color Grade"],
  },
  {
    no: "02",
    title: "Commercial Production",
    desc: "High-impact commercials engineered for attention — concept, crew, and post handled end to end.",
    tags: ["TVC", "Product", "Direction"],
  },
  {
    no: "03",
    title: "Aerial & Landscape",
    desc: "Drone cinematography that captures the vast, untamed geometry of the desert and beyond.",
    tags: ["Drone", "Landscape", "4K/6K"],
  },
  {
    no: "04",
    title: "Documentary",
    desc: "Long-form storytelling that follows the truth patiently — interviews, vérité, and archival craft.",
    tags: ["Interview", "Vérité", "Story"],
  },
  {
    no: "05",
    title: "Events & Live",
    desc: "Multi-camera coverage for launches and gatherings — captured live, delivered fast.",
    tags: ["Multi-cam", "Live", "Recap"],
  },
];

export const PORTFOLIO = [
  {
    id: "p1",
    title: "Driving Tradition",
    category: "Brand Film",
    year: "2025",
    thumb: "https://customer-assets.emergentagent.com/job_dune-productions/artifacts/ndx10c5e_Final%20VO%20mix.00_01_09_09.Still001.webp",
    vimeoId: "942212698",
  },
  {
    id: "p2",
    title: "Echoes of Valor",
    category: "Documentary",
    year: "2025",
    thumb: "https://customer-assets.emergentagent.com/job_dune-productions/artifacts/77j8nw3o_699731211_1803777141060293_1017142188851734071_n.jpg",
    link: "https://www.echoesofvalor.org",
  },
  {
    id: "p3",
    title: "Nightfall",
    category: "Commercial",
    year: "2024",
    thumb: "https://customer-assets.emergentagent.com/job_dune-productions/artifacts/w24ifuob_13693052_10201833708001317_441654772065006527_o.webp",
    status: "In Progress",
  },
  {
    id: "p4",
    title: "A Matter of Faith",
    category: "Documentary",
    year: "2023",
    thumb: "https://customer-assets.emergentagent.com/job_dune-productions/artifacts/z28ap3ov_matter-of-faith-%281%29.webp",
    youtubeId: "2eLg2OMuukY",
    start: 24,
  },
];

export const PHOTO_GALLERY = [
  { src: "https://customer-assets.emergentagent.com/job_dune-productions/artifacts/cqxstxd8_11754815_10200737676881224_2422324402603758540_o.webp" },
  { src: "https://customer-assets.emergentagent.com/job_dune-productions/artifacts/l06vj25w_DSCF8602.webp" },
  { src: "https://customer-assets.emergentagent.com/job_dune-productions/artifacts/q5l83nqa_2019_0113_22414300.webp" },
  { src: "https://customer-assets.emergentagent.com/job_dune-productions/artifacts/qrypa1tg_DJI_20230801194257_0007_D.webp" },
  { src: "https://customer-assets.emergentagent.com/job_dune-productions/artifacts/8gh3845f_18623483_10203115368402026_3667664756795877143_o.jpg" },
  { src: "https://customer-assets.emergentagent.com/job_dune-productions/artifacts/i5wfzkld_2022_0708_08011700.jpg" },
  { src: "https://customer-assets.emergentagent.com/job_dune-productions/artifacts/wqfl9271_DSCF2976.webp" },
  { src: "https://customer-assets.emergentagent.com/job_dune-productions/artifacts/wyqsx2ru_DSCF2766.webp" },
  { src: "https://customer-assets.emergentagent.com/job_dune-productions/artifacts/ghe6zm71_2022_0708_08011500.jpg" },
  { src: "https://customer-assets.emergentagent.com/job_dune-productions/artifacts/ru2gb7b4_2022_0708_08010100.jpg" },
  { src: "https://customer-assets.emergentagent.com/job_dune-productions/artifacts/okkhhrlo_DSCF5206.webp" },
  { src: "https://customer-assets.emergentagent.com/job_dune-productions/artifacts/w3sqhjuq_DSCF5178.webp" },
  { src: "https://customer-assets.emergentagent.com/job_dune-productions/artifacts/mf606txk_DSCF4961.webp" },
  { src: "https://customer-assets.emergentagent.com/job_dune-productions/artifacts/6xujb2kn_DSCF4947.webp" },
  { src: "https://customer-assets.emergentagent.com/job_dune-productions/artifacts/355d4vq6_DSCF4945.webp" },
];


export const STATS = [
  { value: "12+", label: "Years in the field" },
  { value: "340", label: "Films delivered" },
  { value: "28", label: "Awards & mentions" },
  { value: "6K", label: "Cinema resolution" },
];

export const PROCESS = [
  { no: "01", title: "Listen", desc: "We start with your story — the why beneath the what." },
  { no: "02", title: "Frame", desc: "Concept, treatment, and a shot language built for it." },
  { no: "03", title: "Capture", desc: "A lean, expert crew shoots with intent, not excess." },
  { no: "04", title: "Deliver", desc: "Edit, sound, and grade — polished until it moves people." },
];


export const TOP_TIER = [
  {
    id: "toptier_10k",
    name: "Essential",
    price: 10000,
    tagline: "End-to-end commercial, built to convert.",
    includes: [
      "Full creative development & concepting",
      "Professional production (crew, gear, direction)",
      "Complete post-production & finishing",
      "Ad campaign on social media platforms",
      "Campaign placement for lead generation",
    ],
    featured: false,
  },
  {
    id: "toptier_12k",
    name: "Signature",
    price: 12000,
    tagline: "Maximum reach across social + streaming.",
    includes: [
      "Full creative development & concepting",
      "Premium production (crew, gear, direction)",
      "Complete post-production & finishing",
      "Ad campaign on social media AND popular streaming platforms",
      "Expanded campaign placement for lead generation",
    ],
    featured: true,
  },
];

export const DAY_IN_LIFE = {
  id: "day_in_life",
  name: "Day in the Life",
  price: 3500,
  tagline: "A documentary portrait of your business.",
  desc: "An in-depth, emotional look at how your business truly operates — told through a series of day and night shoots.",
  waveLink: "https://link.waveapps.com/kca9bg-uqtwz3",
  includes: [
    "Multiple day & night shoots for your business",
    "An in-depth, emotional look at how your business operates",
    "Candid, real work moments",
    "Interviews with employees, owners & customers",
  ],
};

export const ADDONS = [
  {
    id: "client_testimonials",
    name: "Client Testimonials",
    price: 275,
    desc: "We contact your top customers and capture their business relationship with you — perfect, authentic content for your social media.",
    note: "Minimum of 3 bookings required.",
    waveLink: "https://link.waveapps.com/ru6jek-xm2mub",
  },
  {
    id: "day_rate",
    name: "Standard Day Rate",
    price: 350,
    desc: "Up to three hours of on-location shooting and coverage — flexible production time for whatever your project needs.",
    unit: "/ up to 3 hrs",
    waveLink: "https://link.waveapps.com/sn8a6d-987evh",
  },
];

export const CONTENT_PARTNER = {
  id: "content_partner",
  name: "Social Media Content Partner",
  price: 1025,
  cadence: "/month",
  tagline: "An ongoing creative team for your brand's social presence.",
  desc: "A monthly partnership that keeps your channels fed with cinematic, on-brand content — planned, shot, and delivered on a steady cadence.",
  includes: [
    "2–3 content days per month",
    "Photo & video created for social media",
    "Minor ad placements",
    "Narrative commercial included",
    "12-month working agreement",
  ],
};

export const WEDDING_PACKAGES = [
  {
    id: "wedding_day",
    name: "Wedding Day",
    price: 2200,
    tagline: "Your wedding day, beautifully captured.",
    desc: "A focused package covering the wedding day itself — ceremony and reception. A polished highlight reel plus your raw footage.",
    includes: [
      "Ceremony & reception coverage (wedding day only)",
      "1 professional camera operator",
      "3–5 minute highlight video",
      "Digital delivery of raw footage",
    ],
    excludes: "No bridal session included",
    featured: false,
    waveLink: "https://link.waveapps.com/kpz66m-ch8tcp",
  },
  {
    id: "wedding_bridal",
    name: "Bridal + Highlight",
    price: 4300,
    tagline: "Every moment, beautifully preserved.",
    desc: "Comprehensive coverage from bridal session through ceremony and reception, with a full bridal video and all raw footage archived.",
    includes: [
      "Bridal session, ceremony & reception coverage",
      "2–3 professional camera operators",
      "3–5 minute highlight video",
      "Full bridal video",
      "4 TB hard drive with all raw footage",
    ],
    excludes: "No mini-documentary",
    featured: true,
    waveLink: "https://link.waveapps.com/rtc6py-m7w5kg",
  },
  {
    id: "wedding_full",
    name: "Full Wedding",
    price: 5800,
    tagline: "The complete story, start to finish.",
    desc: "Our signature package — bridal session, full-day coverage, highlight reel, full bridal video, and a mini-documentary with interviews and professional audio.",
    includes: [
      "Bridal session, ceremony & reception coverage",
      "2–3 professional camera operators",
      "3–5 minute highlight video",
      "Full bridal video",
      "Mini-documentary — interviews, candid moments & audio",
      "4 TB hard drive with all raw footage",
    ],
    excludes: null,
    featured: false,
    waveLink: "https://link.waveapps.com/ynwxej-3y2ff5",
  },
  {
    id: "wedding_luxury",
    name: "Full Wedding + Luxury",
    price: 8000,
    tagline: "The complete story, elevated.",
    desc: "Everything in the Full Wedding package, plus a luxury portable restroom for your wedding and reception — through our partnership with Southern Utah Event Rentals.",
    includes: [
      "Bridal session, ceremony & reception coverage",
      "2–3 professional camera operators",
      "3–5 minute highlight video",
      "Full bridal video",
      "Mini-documentary — interviews, candid moments & audio",
      "4 TB hard drive with all raw footage",
      "Luxury portable restroom for wedding & reception (w/ Southern Utah Event Rentals)",
    ],
    excludes: null,
    featured: false,
    waveLink: "https://link.waveapps.com/vmj7k6-cbtpek",
  },
];
